/**
 * Created by pajicv on 10/12/18.
 */
import React from 'react';
import { Typography, withStyles, Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import Spinner from 'react-spinkit';
import classnames from 'classnames';
import { MAIN_COLOR } from '../../firebase-config';

const styles = theme => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  tabs: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '33%'
  },
  title: {
    fontSize: 30,
  },
    titleBig: {
        fontSize: 44,
    },
  tab: {
    padding: 10
  },
  selected: {
    fontWeight: 'bold'
  },
    addButton: {
      width: 40,
      height: 40
    }
});

class CyclesBar extends React.Component {
  render() {
    const { cycles, projectTitle, selectedCycle, onCycleClick, classes, isCreatingCycle, onAddCycle } = this.props;
    const selectedCycleIndex = cycles[selectedCycle].index;
    return (
      <div className={classes.container}>
        <div style={{width: '33%', textAlign: 'left'}}>
          <Typography className={classes.title}>{`${projectTitle}`}</Typography>
        </div>
        <div style={{width: '34%', textAlign: 'center'}}>
          <Typography className={classes.titleBig}>CX Cycle</Typography>
        </div>
        <div className={classes.tabs}>
          {
            Object.keys(cycles).map((cycleId) => {
              const { index } = cycles[cycleId];
              return (
                <div className={classes.tab} onClick={() => onCycleClick(cycleId)}>
                  <Typography className={
                    (cycleId === selectedCycle)
                      ? classnames(classes.title, classes.selected)
                      : classes.title
                  }>
                    {`Cy${index + 1}`}
                  </Typography>
                </div>
              );
            })
          }
          <div className={classes.tab}>
            <Button
                className={classes.addButton}
                variant="fab"
                color="primary"
                aria-label="Add"
                onClick={onAddCycle}
            >
              <AddIcon />
            </Button>
              {isCreatingCycle && <Spinner name="circle" color={MAIN_COLOR} /> }
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(CyclesBar);



// WEBPACK FOOTER //
// ./src/components/Cycles/CyclesBar.js